import { graphql } from "../graphql";
import query from "./query.gql";
import { RepoErrorEnum } from "../repo-error.enum";

export async function fetchCurrentSubscriptionId(
  businessId: string
): Promise<string> {
  try {
    const response = await graphql.query({
      query,
      variables: {
        businessId,
      },
    });

    return response.data.subscription.id;
  } catch {
    throw new Error(RepoErrorEnum.NETWORK_ERROR);
  }
}
